export const numGroup = (value: number | null): string => {
  if (value === null) return '-';
  return value
    ?.toString()
    .split(/(?=(?:...)*$)/)
    .join(' ');
};

function rnd(n: number, precision: number) {
  const prec = 10 ** precision;
  return Math.round(n * prec) / prec;
}

export function getFriendlyNum(n: number) {
  const abbrev = ['тыс.', 'млн.'];
  let base = Math.floor(Math.log(Math.abs(n)) / Math.log(1000));
  const suffix = abbrev[Math.min(abbrev.length - 1, base - 1)];
  base = abbrev.indexOf(suffix) + 1;
  return suffix ? rnd(n / 1000 ** base, 2) + ' ' + suffix : '' + n;
}
